(function() {
	Vue.component('nominow-export-file', {
		template: `
    <div>
    <div class="mui-textfield">
    <input type="text" v-model="name" id="export-name" data-val="true" data-val-required="required"/>
    <label>Name</label>
    </div>
    <div class="field">
    <label class="label">Type</label>
    <div class="field is-narrow">
    <div class="control">
    <label class="radio">
    <input type="radio" v-model="filetype" value="CSV">
    <span class="disc"></span>
    <div class="subject">CSV</div>
    </label>
    </div>
    </div>
    </div>
    <div class="has-text-right">
    <button class="button is-primary" v-on:click="store">Save</button>
    </div>
    </div>
    `,
		props: {
			data: {
				type: Object,
				required: true,
				default: () => ({
					parentGuid: null,
					selectionGuid: null
				})
			}
		},
		data: function() {
			return {
				name: null,
				filetype: 'CSV'
			};
		},
		mounted: function() {
			$('input:first', this.$el).focus();
		},
		created: function() {},
		methods: {
			store: function() {
				const self = this;
				toggleLoader(true);
				const queueitem = {
					name: this.name,
					type: 'EXPORT',
					parentGuid: this.data.parentGuid == null ? this.data.selectionGuid : this.data.parentGuid,
					childGuid: this.data.parentGuid == null ? null : this.data.selectionGuid,
					userGuid: window.nominowUserguid,
					options: {
						fileType: this.filetype
					}
				};
				POST('/baas/nominow_insight/addinsightaction', queueitem)
					.then(xhr => {
						self.$parent.componentmodal = null;
						window.initToast('Export queued', 'success');
						toggleLoader(false);
					})
					.catch(xhr => {
						alert('argh');
					});
			}
		}
	});
})();
